import { NgModule } from '@angular/core';
import { SolidSessionService } from './session/solid-session.service';
import { PermissionCheckerService } from './auth/permission-checker.service';
import { FeatureCheckerService } from './features/feature-checker.service';
import { LocalizationService } from './localization/localization.service';
import { SettingService } from './settings/setting.service';
import { NotifyService } from './notify/notify.service';
import { MessageService } from './message/message.service';
import { LogService } from './log/log.service';
import { SolidMultiTenancyService } from './multi-tenancy/solid-multi-tenancy.service';
import { SolidHttpConfiguration } from './solidHttpInterceptor';
import { SolidUserConfigurationService } from './solid-user-configuration.service';
import { TokenService } from './auth/token.service';
import { UtilsService } from './utils/utils.service';

@NgModule({
    declarations: [
    ],

    providers: [
        SolidSessionService,
        PermissionCheckerService,
        FeatureCheckerService,
        LocalizationService,
        SettingService,
        NotifyService,
        MessageService,
        LogService,
        SolidMultiTenancyService,
        SolidUserConfigurationService,
        SolidHttpConfiguration,
        TokenService,
        UtilsService
    ]
})
export class SolidModule { }